import { Table } from 'antd';
import { getTableColumns } from './constants';
import { isMobile } from '../../../../../../services/clientService';

import './index.scss';

export const ClientsTable = ({ isLoading, data }) => {
  const tableScroll = {
    scrollToFirstRowOnChange: true,
    x: isMobile() ? true : '',
  };

  return (
    <Table
      rowKey="address"
      loading={isLoading}
      columns={getTableColumns()}
      dataSource={data || []}
      scroll={tableScroll}
      className="clients-table"
    />
  );
};
